/* ==========================================================================
   HEADER
   ========================================================================== */

import { checkBlockVisibility } from "../utilities/element-visibility";

function headerHeight() {
  const header = document.querySelector<HTMLElement>("#header");
  var body = document.querySelector<HTMLElement>("body");
  if (!header || !body) return;
  body.style.setProperty("--header-height", header.clientHeight + "px");
}

function headerBackground() {
  const header = document.querySelector<HTMLElement>("#header");
  if (!header) return;

  const wpadminbar = document.querySelector<HTMLElement>("#wpadminbar");
  const wpadminbarHeight = wpadminbar
    ? window.innerWidth >= 600
      ? wpadminbar.clientHeight
      : 0
    : 0;

  for (const block of document.querySelectorAll<HTMLDivElement>(
    ".content-builder-block"
  )) {
    if (
      checkBlockVisibility(
        block,
        header.clientHeight + wpadminbarHeight + 10
      ) &&
      !block.closest(".js-modal")
    ) {
      if (block.classList.contains("bg-white")) {
        header.classList.add("text-black");
        header.classList.remove("text-white");
      } else {
        header.classList.add("text-white");
        header.classList.remove("text-black");
      }

      if (block.classList.contains("intro-section")) {
        header.classList.remove("bg-black");
        header.classList.remove("bg-white");
      } else {
        if (block.classList.contains("bg-white")) {
          header.classList.add("bg-white");
          header.classList.remove("bg-black");
        } else {
          header.classList.add("bg-black");
          header.classList.remove("bg-white");
        }
      }
    }
  }
}

function headerOpacity() {
  const header = document.querySelector<HTMLElement>("#header");
  if (!header) return;

  if (document.body.classList.contains("home")) {
    if (window.innerHeight >= window.scrollY) {
      header.classList.add("opacity-0");
    } else {
      header.classList.remove("opacity-0");
    }
  } else {
    header.classList.remove("opacity-0");
  }
}

window.addEventListener("load", function () {
  headerHeight();
  headerOpacity();
  headerBackground();
});

window.addEventListener("resize", function () {
  headerHeight();
  headerOpacity();
  headerBackground();
});

window.addEventListener("scroll", function () {
  headerOpacity();
  headerBackground();
});
